import React from 'react';

import type { BlockchainNetwork } from '@zealy/utils';
import { isBlockchainVerified } from '@zealy/utils';

import type { Identification } from '#constants/quests/Task.constants';

import ConnectDiscord from './ConnectDiscord';
import ConnectEmail from './ConnectEmail';
import ConnectTelegram from './ConnectTelegram';
import ConnectTiktok from './ConnectTiktok';
import { ConnectTwitter } from './ConnectTwitter';
import ConnectWallet from './ConnectWallet';
import InputBlockchainAddress from './InputBlockchainAddress';

export const ConnectField = ({ type }: { type: Identification }) => {
  console.log(type);
  switch (type) {
    case 'discord':
      return <ConnectDiscord />;
    case 'twitter':
    case 'twitterBlue':
      return <ConnectTwitter />;
    case 'tiktok':
      return <ConnectTiktok />;
    case 'email':
      return <ConnectEmail />;
    case 'telegram':
      return <ConnectTelegram />;
    default: {
      return isBlockchainVerified(type) ? (
        <ConnectWallet blockchain={type as BlockchainNetwork} />
      ) : (
        <InputBlockchainAddress blockchain={type} />
      );
    }
  }
};
